// extracted by mini-css-extract-plugin
module.exports = {"tabLink":"_tabs_tabLink__0YxAQ","tabLinkActive":"_tabs_tabLinkActive___w8n8"};